
import { defineComponent, ref } from 'vue';

import { useRouter } from 'vue-router';
import { mdiChevronRight } from '@mdi/js';

import LoginContainer from '@/components/LoginContainer.vue';

export default defineComponent({
  components: {
    LoginContainer,
  },
  setup() {
    const router = useRouter();

    router.push({ name: 'Login' });

    const login = () => {
      router.push({ name: 'Login' });
    };

    return {
      login,
      mdiChevronRight,
    };
  },
});
